import { ReactNode, useState } from "react";
import { useEffectOnce } from "react-use";
import Image from "next/image";
import { useAboutUsPageContext } from "@/src/features/about-us/AboutUsPageContext";
import { useAppContext } from "@/src/config/AppProvider";
import { useTranslation } from "next-i18next";
import DOMPurify from "isomorphic-dompurify";

const AboutSection = (): ReactNode => {
  const { institutional, vision, mission, documents } = useAboutUsPageContext();
  const { licenceSettings } = useAppContext();
  const { t } = useTranslation();
  const [sanitizedInstitutional, setSanitizedInstitutional] = useState<string>("");
  const [sanitizedVision, setSanitizedVision] = useState<string>("");
  const [sanitizedMission, setSanitizedMission] = useState<string>("");

  useEffectOnce(() => {
    setSanitizedInstitutional(DOMPurify.sanitize(institutional.Content));
    setSanitizedVision(DOMPurify.sanitize(vision.Content));
    setSanitizedMission(DOMPurify.sanitize(mission.Content));
  });

  return (
    <div className="rbt-about-area about-style-1 bg-color-white rbt-section-gapBottom">
      <div className="container">
        <div className="row g-5 align-items-center">
          <div className="col-lg-6">
            <div className="thumbnail-wrapper">
              <div className="thumbnail">
                {documents
                  ?.sort((a, b) => Number(a.FileName) - Number(b.FileName))
                  .map((document, index) => {
                    const width = index === 0 ? 366 : index === 1 ? 308 : 405;
                    const height = index === 0 ? 490 : index === 1 ? 250 : 490;

                    return (
                      <div key={document.IdGuid} className={`thumbnail image-${index + 1}`}>
                        <Image src={document.FileUrl} width={width} height={height} alt={document.FileDescription} />
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="inner pl--50 pl_sm--0 pl_md--0">
              <div className="section-title text-start">
                <span className="subtitle bg-coral-opacity">{institutional.Category.Name}</span>
                <h2 className="title">{licenceSettings.SiteTitle}</h2>
              </div>
              <p className="description mt--30" dangerouslySetInnerHTML={{ __html: sanitizedInstitutional }}></p>
              <div className="rbt-feature-wrapper mt--40">
                <div className="rbt-feature feature-style-1">
                  <div className="icon bg-pink-opacity">
                    <i className="feather-monitor"></i>
                  </div>
                  <div className="feature-content">
                    <h6 className="feature-title">{t("vision")}</h6>
                    <p className="feature-description" dangerouslySetInnerHTML={{ __html: sanitizedVision }}></p>
                  </div>
                </div>
                <div className="rbt-feature feature-style-1">
                  <div className="icon bg-primary-opacity">
                    <i className="feather-book"></i>
                  </div>
                  <div className="feature-content">
                    <h6 className="feature-title">{t("mission")}</h6>
                    <p className="feature-description" dangerouslySetInnerHTML={{ __html: sanitizedMission }}></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
